import React, { useEffect, useRef } from 'react';
import OverflowTip from '../OverflowTip/OverflowTip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as _ from 'lodash';

import Pagination from '@material-ui/lab/Pagination';
import clsx from 'clsx';

import { useStyles } from './styles';
import './TableChart.scss';

const Cell = (props) => {
  const { children } = props;
  return (
    //shop-table-cell ヘッダーの１セル
    <TableCell className="shop-table-cell" style={props.style} >
      <div className="table-cell-content">
        {React.Children.map(children, child => {
          return <OverflowTip>{child}</OverflowTip>
        })}
      </div>
    </TableCell>
  )
}

/**
 * ヘッダー
 * @param {*} props
 */
const Header = (props) => {
  const { cols } = props;
  return (
    <TableHead className="shop-table-head">
      <TableRow className="shop-table-head-row">
        {cols.map(col => {
          let style = col.width ? { minWidth: col.width, maxWidth: 'auto', width: col.width, } : { width: 'auto' };
          return (<Cell className="normal-cell" key={col.name} style={style}> {col.label} </Cell>)
        })}
      </TableRow>
    </TableHead>
  )
}

/**
 * テーブルコンポーネント
 * @param {*} props
 */
export default function TableChart(props) {
  const { cols, data, idCol, id, firstRowBlue, count } = props;
  const classes = useStyles();

  const createData = (data) => {
    let q = _.chain(data).map(d => {
      return d;
    });
    return q.value();
  }

  const isFirstRowBlue = firstRowBlue ? "shop-table-body-row-blue" : "shop-table-body-row"

  const [page, setPage] = React.useState(1);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // countがある場合はページネーション機能あり
  // 表示件数変更時
  useEffect(() => {
    setPage(1)
  }, [count]);
  const pageCount = page - 1
  const countProps = count ? count : 9999

  return (
    <div id={'shop-table-wrp'}>

      {countProps != 9999 &&
        //ページネーション
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Pagination
            className={clsx(classes.pagination)}
            count={Math.ceil(data.length / count)}
            rowsPerPage={count}
            page={page}
            onChange={handleChangePage}
          // hidePrevButton
          // hideNextButton
          />
        </div>}

      <Table className="shop-table" id={id}>
        {(() => { return <Header cols={cols} /> })()}

        <TableBody className="shop-table-body">
          {createData(data.slice(pageCount * countProps, pageCount * countProps + countProps)).map((row) => {
            return (
              <TableRow className={isFirstRowBlue} key={row[idCol]}>
                {cols.map(col => {
                  let style = col.width ? { minWidth: col.width, maxWidth: 'auto', width: col.width, } : { width: 'auto' };
                  return <TableCell key={col.name} align={col.align} style={style}>
                    {row[col.name]}
                  </TableCell>
                })}
              </TableRow>);
          })}
        </TableBody>
      </Table>

      {countProps != 9999 &&
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Pagination
            className={clsx(classes.pagination)}
            count={Math.ceil(data.length / count)}
            rowsPerPage={count}
            page={page}
            onChange={handleChangePage}
          // hidePrevButton
          // hideNextButton
          />
        </div>}

    </div>
  );
}
